import {
  BrowserPlatformDevice,
  IDevice,
  ICoreFactory,
  BaseCoreFactory,
  WebLogger,
  ILogger,
  WebCobranding,
  ICobranding,
  RegionResolver,
} from '@amzn/work-spaces-web-client-core-lib';
import { HttpClientFactory } from '../HttpClientFactory';

export class WebCoreFactory extends BaseCoreFactory implements ICoreFactory {
  protected _cobranding?: ICobranding;
  protected _regionResolver?: RegionResolver;
  getHttpClientFactory() {
    return HttpClientFactory;
  }

  getDevice(): IDevice {
    if (!this._device) {
      this._device = new BrowserPlatformDevice(this.getPersistentStorage());
    }
    return this._device;
  }

  getLogger(): ILogger {
    if (!this._logger) {
      const device = this.getDevice();
      this._logger = new WebLogger(device);
    }
    return this._logger;
  }

  getRTCChannel() {
    return null;
  }

  getCobranding(): ICobranding {
    if (!this._cobranding) {
      this._cobranding = new WebCobranding(
        this.getLogger(),
        this.getMetrics(),
        this.getHttpClientWithFallback()
      );
    }
    return this._cobranding;
  }

  getRegionResolver() {
    if (this._regionResolver == null) {
      this._regionResolver = new RegionResolver(
        this.getLogger(),
        this.getMetrics(),
        HttpClientFactory.getHttpClient(),
        this.getRTCChannel()
      );
    }
    return this._regionResolver;
  }
}
